import * as React from 'react';
import classNames from 'classnames';
import { MotorButtonCircle } from './MotorButtonCircle';
import { BaseMotorButtonProps, ButtonSize, stateStyles } from './buttonStates';
import { ButtonColor } from './Button';

export const motorButtonStyle = (
  size: ButtonSize | undefined,
  color: ButtonColor,
  darkMode?: boolean
) => {
  return classNames(
    'flex rounded-full items-center border-none group',
    size === 'small' ? 'gap-2' : 'gap-3',
    {
      'text-button-label-s h-8 pr-4': size === 'small',
      'text-button-label-s h-10 pr-4': size === 'medium',
      'text-button-label-l h-12 pr-4': size === 'large',
    },
    darkMode ? 'text-white' : 'text-midnight',
    stateStyles[color][darkMode ? 'darkMode' : 'lightMode'].focus
  );
};

type MotorButtonProps = BaseMotorButtonProps & {
  type?: 'button' | 'submit';
};

export const MotorButton: React.FunctionComponent<MotorButtonProps> = ({
  color,
  darkMode,
  size,
  icon,
  children,
  disabled,
  onClick,
  onMouseEnter,
  onMouseLeave,
  'data-testid': data_test_id,
  'aria-describedby': aria_describedby,
  type,
}) => {
  return (
    <button
      disabled={disabled}
      data-testid={data_test_id}
      aria-describedby={aria_describedby}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      className={classNames(motorButtonStyle(size, color, darkMode))}
      type={type === 'submit' ? 'submit' : 'button'}
    >
      <MotorButtonCircle size={size} icon={icon} color={color} darkMode={darkMode} />
      {children}
    </button>
  );
};
